import React from "react";
import "./RightSidebar.css";
import comment from "../../assets/comment-alt-solid.svg";
import pen from "../../assets/pen-solid.svg";
import blackLogo from "../../assets/blacklogo.svg";

const Widget = () => {
  return (
    <div className="widget">
      <h4>From the Dev Q Blog</h4>
      <div className="right-sidebar-div-1">
        <div className="right-sidebar-div-2">
          <img src={pen} alt="pen" width="18" />
          <p>
            Why clean code matters more than ever in modern web development
          </p>
        </div>
        <div className="right-sidebar-div-2">
          <img src={pen} alt="pen" width="18" />
          <p>Understanding JWT authentication the simple way</p>
        </div>
      </div>

      <h4>Featured on Dev Q</h4>
      <div className="right-sidebar-div-1">
        <div className="right-sidebar-div-2">
          <img src={comment} alt="comment" width="18" />
          <p>New reputation system improvements released</p>
        </div>
        <div className="right-sidebar-div-2">
          <img src={comment} alt="comment" width="18" />
          <p>Please welcome our top contributors of the month 🎉</p>
        </div>
        <div className="right-sidebar-div-2">
          <img src={comment} alt="devq" width="18" />
          <p>
            Outdated answers: accepted answers now automatically highlighted on
            Dev Q
          </p>
        </div>
      </div>

      <h4>Hot Dev Q Discussions</h4>
      <div className="right-sidebar-div-1">
        <div className="right-sidebar-div-2">
          <p>38</p>
          <p>
            Why was this answer downvoted even though it works perfectly?
          </p>
        </div>
        <div className="right-sidebar-div-2">
          <p>20</p>
          <p>
            Best practices for structuring a MERN stack project?
          </p>
        </div>
        <div className="right-sidebar-div-2">
          <p>14</p>
          <p>Is adding screenshots in questions always recommended?</p>
        </div>
      </div>
    </div>
  );
};

export default Widget;
